/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Not_AssignedInputs */

const en_player_not_assigned = /** @type {(inputs: Player_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrollment not found.`)
};

const ja_player_not_assigned = /** @type {(inputs: Player_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録情報が見つかりません。`)
};

const fr_player_not_assigned = /** @type {(inputs: Player_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription non trouvée.`)
};

const de_player_not_assigned = /** @type {(inputs: Player_Not_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einschreibung nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Enrollment not found." |
*
* @param {Player_Not_AssignedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_not_assigned = /** @type {((inputs?: Player_Not_AssignedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Not_AssignedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_not_assigned(inputs)
	if (locale === "ja") return ja_player_not_assigned(inputs)
	if (locale === "fr") return fr_player_not_assigned(inputs)
	return de_player_not_assigned(inputs)
});